module.exports = {"411003001":"许由街道","411003002":"新元街道","411003003":"邓庄街道","411003004":"昌盛街道","411003100":"将官池镇","411003101":"五女店镇","411003102":"尚集镇","411003103":"苏桥镇","411003104":"蒋李集镇","411003105":"张潘镇","411003106":"灵井镇","411003200":"陈曹乡","411003202":"小召乡","411003203":"河街乡","411003204":"桂村乡","411003205":"椹涧乡","411003206":"榆林乡","411003208":"艾庄回族乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/411003.json
// module id = 1739
// module chunks = 0